import React from 'react';
import parse from 'html-react-parser';
import LoadingContainer from '@ecs/tng-common/src/components/loading-container/LoadingContainer';
import SEO from '@ecs/tng-common/src/components/seo/SEO';
import LayoutLess from '../components/LayoutLess';

type pageContextType = {
  contentUrl: string;
  title: string;
  description: string;
  dataOp: string;
  dataSection?: string;
  dataCategory?: string;
  noindex?: boolean;
  seoChildren?: string;
};
type PageProps = {
  pageContext: pageContextType;
};
export class DynamicContentPages extends React.Component<PageProps> {
  pageContext = this.props.pageContext;

  async componentDidMount() {
    const content = await fetch(this.pageContext.contentUrl);
    const data = await content.json();
    const contentWrapper = document.getElementById('content-wrapper');
    if (contentWrapper?.innerHTML && data?.content) {
      contentWrapper.innerHTML = data.content;
    }
  }

  render() {
    return (
      <LayoutLess>
        <div
          id="content-wrapper"
          className="container container-sm-py position-relative">
          <LoadingContainer state />
        </div>
      </LayoutLess>
    );
  }
}

export default DynamicContentPages;

export function Head(props: PageProps) {
  return (
    <>
      <body
        data-op={props.pageContext.dataOp}
        data-section={props.pageContext.dataSection || 'ecom-service'}
        data-category={props.pageContext.dataCategory || 'service'}
      />
      <SEO
        title={props.pageContext.title}
        description={props.pageContext.description}
        {...(props.pageContext.noindex ? { noindex: true } : {})}>
        {props.pageContext.seoChildren && parse(props.pageContext.seoChildren)}
      </SEO>
    </>
  );
}
